import { render, staticRenderFns } from "./Popper.vue?vue&type=template&id=4dd2b27c&scoped=true"
import script from "./Popper.vue?vue&type=script&lang=js"
export * from "./Popper.vue?vue&type=script&lang=js"
import style0 from "./Popper.vue?vue&type=style&index=0&id=4dd2b27c&prod&lang=css"
import style1 from "./Popper.vue?vue&type=style&index=1&id=4dd2b27c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd2b27c",
  null
  
)

export default component.exports